<template>
  <div v-bind:class="{ 'locale-switcher': !mobile }">
    <b-nav-item>
      <b-link @click="doShowModal(true)">
        <flag :iso="getFlagLanguageString(currentLocale)" :squared="false"></flag>
      </b-link>
    </b-nav-item>

    <b-modal id="languageModal" ref="languageModalRef" centered
             size="sm" :hide-header="true" :hide-footer="true">
      <b-list-group>
        <b-list-group-item
          button
          :active="locale === currentLocale"
          v-for="locale in locales"
          :key="locale"
          @click="setLocale(locale)">
          <flag :iso="getFlagLanguageString(locale)" :squared="false"></flag>{{ getLanguageString(locale) }}
        </b-list-group-item>
      </b-list-group>
    </b-modal>
  </div>
</template>

<script>
const localeStrings = {
  en: 'English',
  nl: 'Nederlands',
  fr: 'Français',
  de: 'Deutsch'
}

export default {
  name: 'localeswitcher',
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      locales: ['nl', 'en'],
      showModal: false
    }
  },
  computed: {
    currentLocale: function () {
      return this.$i18n.locale
    }
  },
  methods: {
    setLocale: function (locale) {
      this.$store.commit('language', locale)
      this.$i18n.locale = locale
      this.$root.$emit('updateLocale')

      this.doShowModal(false)
    },
    getLanguageString: function (locale) {
      return localeStrings[locale]
    },
    getFlagLanguageString: function (locale) {
      if (locale === 'en') {
        return 'gb'
      }
      return locale
    },
    doShowModal: function (show) {
      this.showModal = show
      if (show) {
        this.$refs.languageModalRef.show()
      } else {
        this.$refs.languageModalRef.hide()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .locale-switcher {
    padding-top: 0px;
  }

  .flag-icon {
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/LocaleSwitcher.vue